module.exports = __webpack_public_path__ + "static/media/change-gray.e64cac99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/change-gray.svg
// module id = 1909
// module chunks = 0